var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('el-container',[_c('el-header',{staticStyle:{"z-index":"2022 !important"}},[_c('Header')],1),_c('el-container',[_c('el-main',[_c('Main')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }